function initDynamicTimelineCarousel() {
  if (typeof EmblaCarousel === "undefined") {
    console.warn("EmblaCarousel is not loaded yet, retrying...");
    setTimeout(initDynamicTimelineCarousel, 100);
    return;
  }

  document.querySelectorAll(".dynamic-timeline").forEach((timelineEl) => {
    if (timelineEl.dataset.emblaInitialized === "true") {
      return;
    }

    const viewport = timelineEl.querySelector(
      ".dynamic-timeline-embla-viewport"
    );
    const yearsViewport = timelineEl.querySelector(
      ".dynamic-timeline-years-viewport"
    );
    const yearsContainer = timelineEl.querySelector(".dynamic-timeline-years");
    const yearElements = timelineEl.querySelectorAll(".dynamic-timeline-year");
    const prevButton = timelineEl.querySelector(".dynamic-timeline-prev");
    const nextButton = timelineEl.querySelector(".dynamic-timeline-next");
    const slides = timelineEl.querySelectorAll(".dynamic-timeline-embla-slide");

    if (!viewport || slides.length === 0) {
      return;
    }

    if (slides.length <= 1) {
      if (yearsContainer) yearsContainer.classList.add("hidden");
      if (prevButton) prevButton.classList.add("hidden");
      if (nextButton) nextButton.classList.add("hidden");
      timelineEl.dataset.emblaInitialized = "true";
      return;
    }

    const embla = EmblaCarousel(viewport, {
      align: "center",
      skipSnaps: false,
      containScroll: "trimSnaps",
    });

    let emblaYears = null;
    if (yearsViewport && yearElements.length > 3) {
      emblaYears = EmblaCarousel(yearsViewport, {
        align: "center",
        skipSnaps: false,
        containScroll: "trimSnaps",
        dragFree: true,
      });
    }

    const slideTime = parseFloat(timelineEl.dataset.slideTime) * 1000 || 3000;
    let autoplayInterval;

    const startAutoplay = () => {
      stopAutoplay();
      autoplayInterval = setInterval(() => {
        if (embla.canScrollNext()) {
          embla.scrollNext();
        } else {
          embla.scrollTo(0);
        }
      }, slideTime);
    };

    const stopAutoplay = () => {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    };

    const pauseOnInteraction = () => {
      stopAutoplay();
      setTimeout(startAutoplay, slideTime);
    };

    const startProgressAnimation = () => {
      const selected = embla.selectedScrollSnap();
      const currentYear = yearElements[selected];
      if (currentYear) {
        const progressBar = currentYear.querySelector(
          ".dynamic-timeline-year-progress"
        );
        if (progressBar) {
          progressBar.style.transition = "none";
          progressBar.style.width = "0";

          progressBar.offsetHeight;
          progressBar.style.transition = `width ${slideTime}ms linear`;
          progressBar.style.width = "100%";
        }
      }
    };

    const pauseProgress = () => {
      const selected = embla.selectedScrollSnap();
      const currentYear = yearElements[selected];
      if (currentYear) {
        const progressBar = currentYear.querySelector(
          ".dynamic-timeline-year-progress"
        );
        if (progressBar) {
          const currentWidth = window.getComputedStyle(progressBar).width;
          progressBar.style.transition = "none";
          progressBar.style.width = currentWidth;

          progressBar.offsetHeight;
          progressBar.style.transition = "width 0.3s ease";
          progressBar.style.width = "0";
        }
      }
    };

    let isDragging = false;

    viewport.addEventListener("pointerdown", () => {
      isDragging = true;
      viewport.classList.add("is-grabbing");
      stopAutoplay();
      pauseProgress();
    });

    viewport.addEventListener("pointerup", () => {
      if (isDragging) {
        isDragging = false;
        viewport.classList.remove("is-grabbing");

        startProgressAnimation();
        startAutoplay();
      }
    });

    viewport.addEventListener("pointercancel", () => {
      if (isDragging) {
        isDragging = false;
        viewport.classList.remove("is-grabbing");

        startProgressAnimation();
        startAutoplay();
      }
    });

    if (prevButton) {
      prevButton.addEventListener(
        "click",
        () => {
          embla.scrollPrev();
          pauseOnInteraction();
        },
        { passive: true }
      );
    }

    if (nextButton) {
      nextButton.addEventListener(
        "click",
        () => {
          embla.scrollNext();
          pauseOnInteraction();
        },
        { passive: true }
      );
    }

    const updateActiveYear = () => {
      const selected = embla.selectedScrollSnap();
      yearElements.forEach((yearEl, index) => {
        const progressBar = yearEl.querySelector(
          ".dynamic-timeline-year-progress"
        );

        if (index === selected) {
          yearEl.classList.add("active");

          if (progressBar) {
            progressBar.style.transition = "none";
            progressBar.style.width = "0";

            progressBar.offsetHeight;
            progressBar.style.transition = `width ${slideTime}ms linear`;
            progressBar.style.width = "100%";
          }

          if (emblaYears) {
            emblaYears.scrollTo(index);
          }
        } else {
          yearEl.classList.remove("active");
          if (progressBar) {
            progressBar.style.transition = "none";
            progressBar.style.width = "0";
          }
        }
      });
    };

    yearElements.forEach((yearEl) => {
      yearEl.addEventListener("click", () => {
        const index = parseInt(yearEl.dataset.index);
        embla.scrollTo(index);
      });
    });

    const readMoreButtons = timelineEl.querySelectorAll(
      ".dynamic-timeline-read-more-btn"
    );
    readMoreButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.stopPropagation();
        const slide = btn.closest(".dynamic-timeline-embla-slide");
        const readMoreContent = slide.querySelector(
          ".dynamic-timeline-read-more-content"
        );
        if (readMoreContent) {
          readMoreContent.classList.remove("hidden");
          btn.classList.add("is-expanded");
        }
      });
    });

    embla.on("select", updateActiveYear);
    embla.on("reInit", updateActiveYear);

    embla.on("select", () => {
      stopAutoplay();
      startProgressAnimation();
      startAutoplay();
    });

    updateActiveYear();

    setTimeout(() => {
      startAutoplay();
    }, 100);

    timelineEl.emblaInstance = embla;
    timelineEl.emblaAutoplay = { start: startAutoplay, stop: stopAutoplay };
    timelineEl.dataset.emblaInitialized = "true";
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initDynamicTimelineCarousel);
} else {
  initDynamicTimelineCarousel();
}

if (typeof Shopify !== "undefined" && Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) => {
    const timeline = event.target.querySelector(".dynamic-timeline");
    if (timeline) {
      if (timeline.emblaInstance) {
        if (timeline.emblaAutoplay) {
          timeline.emblaAutoplay.stop();
        }
        timeline.emblaInstance.destroy();
        timeline.dataset.emblaInitialized = "false";
      }
      setTimeout(initDynamicTimelineCarousel, 100);
    }
  });

  document.addEventListener("shopify:section:unload", (event) => {
    const timeline = event.target.querySelector(".dynamic-timeline");
    if (timeline && timeline.emblaAutoplay) {
      timeline.emblaAutoplay.stop();
    }
  });
}
